import { Link } from "react-router-dom";
import "./about.css";

const VALUES = [
  {
    icon: "fa-shield-halved",
    title: "Integrity",
    text: "We believe in doing what is right, always.",
  },
  {
    icon: "fa-lightbulb",
    title: "Innovation",
    text: "We embrace technology and new ideas to create better solutions.",
  },
  {
    icon: "fa-users",
    title: "Client Success",
    text: "Your success is the true measure of our performance.",
  },
  {
    icon: "fa-award",
    title: "Excellence",
    text: "We strive for excellence in our services and customer experience.",
  },
  {
    icon: "fa-bullseye",
    title: "Accountability",
    text: "We own our actions and are accountable to our customers and partners.",
  },
];

const WHY_ITEMS = [
  {
    icon: "fa-magnifying-glass-chart",
    text: "Wide Range of Financial Products",
  },
  {
    icon: "fa-percent",
    text: "Competitive Rates & Best Offers",
  },
  {
    icon: "fa-file-shield",
    text: "Quick Approval & Hassle-Free Process",
  },
  {
    icon: "fa-eye",
    text: "100% Transparent No Hidden Charges",
  },
  {
    icon: "fa-headset",
    text: "Dedicated Support at Every Step",
  },
];

export default function AboutMission() {
  return (
    <>
      <section className="about-mission-new">
        <div className="about-mission-panel">
          <header className="about-section-head">
            <p className="about-eyebrow">OUR MISSION</p>
            <h2 className="about-mission-title">
              Building Financial Freedom for Everyone
            </h2>
            <p className="about-mission-lead">
              Our mission is to empower individuals and businesses with simple,
              smart and secure financial solutions that help them achieve their
              dreams.
            </p>
          </header>

          <div className="about-values-grid">
            {VALUES.map((item) => (
              <article key={item.title} className="about-value-card">
                <span className="about-value-card-icon" aria-hidden="true">
                  <i className={`fa-solid ${item.icon}`} />
                </span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="about-why">
        <div className="about-why-inner">
          <h2 className="about-why-title">WHY CHOOSE GPS FINVEST?</h2>
          <div className="about-why-row">
            {WHY_ITEMS.map((item) => (
              <div key={item.text} className="about-why-item">
                <span className="about-why-icon" aria-hidden="true">
                  <i className={`fa-solid ${item.icon}`} />
                </span>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-final-cta">
        <div className="about-final-cta-inner">
          <div className="about-final-cta-art" aria-hidden="true">
            <img src="/images/about-cta-target.png" alt="" />
          </div>
          <div className="about-final-cta-copy">
            <h2>Let&apos;s Build Your Financial Future Together</h2>
            <p>
              Whether you are investing, borrowing or planning wealth, we are
              here to guide you every step of the way.
            </p>
          </div>
          <Link to="/contact" className="about-final-cta-btn">
            Get Started Today
            <span aria-hidden="true">→</span>
          </Link>
        </div>
      </section>
    </>
  );
}
